// scaleUtils.js
export const DIMENSIONS = {
    lg: {
      width: 450,
      height: 450,
      margin: 100,
      innerRadius: 40,
      labelPadding: 40,
      textWidth: 95,
      fontSize: 12,
      dotRadius: 4,
    },
    md: {
      width: 400,
      height: 400,
      margin: 80,
      innerRadius: 32,
      labelPadding: 40,
      textWidth: 70,
      fontSize: 11,
      dotRadius: 3,
    },
    sm: {
      width: 400,
      height: 400,
      margin: 85,
      innerRadius: 30,
      labelPadding: 35,
      textWidth: 70,
      fontSize: 10,
      dotRadius: 3,
    },
    xs: {
      width: 300,  // Smaller width for mobile
      height: 300, // Smaller height for mobile
      margin: 70,  // Reduced margin
      innerRadius: 25,
      labelPadding: 28,
      textWidth: 60,
      fontSize: 8,
      dotRadius: 2,
    },
  };